<template>
  <div
    class="container mt-4">     
     <div class="row" style="margin-top: 70pt">
      <div class="col center-col">
        <div class="dropdown p-4" id="card">
          <div class="row">
            <div class="col"></div>
            <div class="col center-col">
              <!-- <img class="img-logo" src="../../assets/img/logo_app.png" /> -->
              <img class="img-logo" :src="logo" />
            </div>
            <div class="col"></div>
          </div>          
          <form
            class="px-4 py-3"
            @submit.prevent="signIn"
            style="margin-bottom: 37px"
          >
            <div class="mb-3">
              <i class="fas fa-user icon-name"></i>
              <input
                style="text-transform: uppercase"
                type="text"
                class="form-control"
                v-model.trim="user.nombre"
                :placeholder="$t(`login.user`)"
              />
            </div>
            <div class="mb-3">
              <i class="fas fa-key icon-password"></i>
              <input
                v-if="visPas"
                type="password"
                class="form-control"
                id="exampleDropdownFormPassword1"
                v-model.trim="user.password"
                :placeholder="$t(`login.password`)"
              />
              <input
                v-else
                type="text"
                class="form-control"
                id="epassword"
                v-model.trim="user.password"
              />
              <i
                v-if="!visPas"
                @click="visPas = true"
                class="fas fa-eye-slash field-icon"
              ></i>
              <i
                v-else
                @click="visPas = false"
                class="fas fa-eye field-icon"
              ></i>
            </div>
            <button type="submit" class="btn button" :style="{ backgroundColor: colorCompany }">
              {{ $t("actions.singin") }}
            </button>
          </form>
          <span v-if="error == 1" class="text-danger" style="font-size: 15px">{{
            $t("login.errorUsu")
          }}</span>
          <span
            v-if="error === 2"
            class="text-danger"
            style="font-size: 15px"
            >{{ $t("login.errorBlock") }}</span
          >
          <router-link class="dropdown-item label" :to="restore" style="width: auto">{{
            $t("login.forgot")
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from 'vuex';

export default {
  name: "Login",
  data() {
    return {
      user: {
        nombre: "",
        password: "",
      },
      visPas: true,
      error: 0,
      emp_id: this.$route.params.idemp,
      restore: ""
    };
  },
  created() {
    this.littleDrop();
    this.changeBreadCrumb(17);    
    this.verImagen(this.emp_id);
    this.restore = `/${this.emp_id}/user/restore`
    this.getColorType();
  },
  computed: {
    block() {
      if (!this.user.email.includes("@")) {
        return true;
      }
      if (this.user.password.length > 5) {
        return false;
      }
      return true;
    },
    ...mapState(["colorCompany","servidor","logo"])
  },
  methods: {
    ...mapMutations(['littleDrop','changeBreadCrumb','changeIdUsu','changeTipoUsu','changeIdEmp','changeLogo',"changeColorCompanyGreen","changeColorCompanyBlue","changeColorCompanyRed","changeColorCompanyOrange","changeColorCompany4","changeColorCompany5","changeColorCompany6","changeColorCompany7","changeColorCompany8","changeColorCompany9","changeColorCompany10","changeColorCompany11","changeColorCompany12","changeColorCompany13","changeColorCompany14","changeColorCompany15","changeColorCompany16"]),
    async signIn() {
      if (this.user.nombre === "") {
        this.error = 1;
        return;
      }
      if (this.user.password === "") {
        this.error = 1;
        return;
      }
      const superuser = {
        usu_usuario: this.user.nombre.toUpperCase(),
        usu_clave: this.user.password,
        emp_id: this.emp_id
      };
      try {
        const res = await axios.post(
          `${this.servidor}api/ident_usuario.asp?ac=identificar`,
          superuser
        );
        this.result = res.data.RESULT;       
        const usu_id = res.data.usu_id;
        const usu_rol = res.data.usu_rol;
        // 
        // LO ULTIMO AÑADIDO HA SIDO PARA ALMACENAR EL ID EMPRESA Y QUE EL MENU VERTICAL Y EL NAVBAR FUNCIONEN CORRECTAMENTE
        // CAMBIOS: verImagen(id_emp) this.changeIdEmp(emp_id);
        //
        this.changeIdEmp(this.emp_id);
        this.changeIdUsu(usu_id);
        this.changeTipoUsu(usu_rol);
        this.verImagen(this.emp_id);
        // 1 incorrecta usuario o clave
        // 0 todo bien
        // 2 usuario bloqueado
        if (this.result === "0") {
          this.$router.push(`/${ this.emp_id }/user/ocases`);
        } else if (this.result === "1") {
          this.error = 1;
        } else {
          this.error = 2;
        }
        this.cleanForm();
      } catch (error) {
        console.error(error);
      }
      // VueCookieNext.setCookie("louscd", true, { expire: Infinity });
    },
    cleanForm() {
      this.user = {
        nombre: "",
        password: "",
      };
    },
    verImagen(id_emp) {
      const logo = `${this.servidor}api/ver_logotipo.asp?emp_id=${id_emp}`; 
      this.changeLogo(logo);      
    },
    async getColorType() {
      try {
        const res = await axios.post(
          `${this.servidor}api/op_emp.asp?ac=color&id=${this.emp_id}`
        );
        const color = res.data.emp_color;
        if (color === 0) {
          this.changeColorCompanyOrange();
        } else if (color === 1) {
          this.changeColorCompanyBlue();
        } else if (color === 2) {
          this.changeColorCompanyGreen();
        } else if (color === 3) {
          this.changeColorCompanyRed();
        } else if (color === 4) {
          this.changeColorCompany4();
        } else if (color === 5) {
          this.changeColorCompany5();
        }else if (color === 6) {
          this.changeColorCompany6();
        }else if (color === 7) {
          this.changeColorCompany7();
        }else if (color === 8) {
          this.changeColorCompany8();
        }else if (color === 9) {
          this.changeColorCompany9();
        }else if (color === 10) {
          this.changeColorCompany10();
        }else if (color === 11) {
          this.changeColorCompany11();
        }else if (color === 12) {
          this.changeColorCompany12();
        }else if (color === 13) {
          this.changeColorCompany13();
        }else if (color === 14) {
          this.changeColorCompany14();
        }else if (color === 15) {
          this.changeColorCompany15();
        }else if (color === 16) {
          this.changeColorCompany16();
        }
      } catch (error) {
        console.error(error);
      }    
    }
  },
};
</script>

<style scoped>
#card {
  width: 500px;
  border-radius: 30px;
  background-color: white;
  margin-top: 70px;
}

.field-icon {
  float: right;
  margin-top: -69px;
  position: relative;
  z-index: 2;
  left: -11px;
  cursor: pointer;
}

.icon-name {
  float: left;
  top: 31px;
  position: relative;
  left: 11px;
}

.icon-password {
  float: left;
  top: 31px;
  position: relative;
  left: 11px;
}

.button {
  padding: 10px;
  width: 100%;
  border-radius: 50px;
  color: #fff;
  background-color: #e99417;
}

.label {
  font-size: 10pt;
  color: #a4a9a8;
  margin-top: 19pt;
  float: right;
}

input {
  height: 35pt;
  text-indent: 50px;
}

.center-col {
  display: flex;
  justify-content: center;
}

.img-fondo {
  margin-top: 72pt;
  width: 100%;
  height: 75%;
  position: fixed;
  margin-left: -205pt;
}

.img-logo {
  padding: 5pt;
  width: 225pt;
}
</style>